import { render, staticRenderFns } from "./SetRMN.vue?vue&type=template&id=0f293490"
import script from "./SetRMN.vue?vue&type=script&lang=js"
export * from "./SetRMN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports